import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useOfferCountdown } from '../hooks/useOfferCountdown';
type OfferCountdownInlineProps = {
  className?: string;
  label?: string;
};
export function OfferCountdownInline({
  className = '',
  label = 'Precio de lanzamiento por'
}: OfferCountdownInlineProps) {
  const timeLeft = useOfferCountdown();
  if (!timeLeft) return null;
  const pad = (value: number) => String(value).padStart(2, '0');
  return <p className={`flex items-center gap-2 text-sm text-tinta/65 ${className}`} aria-live="off" data-id="element-164" data-mp="1dts8jvyd4bl6">
      <ClockIcon className="h-4 w-4 shrink-0 text-rosa-dark" strokeWidth={1.8} aria-hidden="true" data-id="element-165" data-mp="141vvnermagww" />
      <span data-id="element-166" data-mp="z3kmz7d26cg9">
        {label}{' '}
        <span className="font-medium tabular-nums text-tinta" data-id="element-167" data-mp="z4cfuaf9tw2u">
          {timeLeft.days}d {pad(timeLeft.hours)}h {pad(timeLeft.minutes)}m{' '}
          {pad(timeLeft.seconds)}s
        </span>
      </span>
    </p>;
}